fechP2P();
async function fechP2P() {
    window.fetchp2p = [];
    let complectFail = false;

    let fetchTarget = ['?getP2P=1'];
    if (Number(window.item['set_scheme'])) fetchTarget.unshift('?getSet=1');

    for (target of fetchTarget) {
        let json;

        try {
            let res = await fetch(target);

            json = await res.json();
            json.items.forEach(cat => {
                if (target == '?getSet=1') {
                    (cat.items || []).forEach(item => { item.set_id = window.item.id });
                }
                window.fetchp2p.push(cat);
            })
        } catch (error) {
            if (target == '?getSet=1') {
                complectFail = true;
                console.log('Не комплект');
            } else console.log('Комлпект');
        }
    }
    if (!Number(window.item['set_scheme']) || complectFail) window.fetchp2p.unshift(window.item);
    if (window.fetchp2p.length > 1) renderP2P();
}

function renderP2P() {
    const catOptionComplect = {
        template: '#optionComplectCat',
        props: ['cat', 'index', 'showAllThreshold', 'showAllEnabled'],
        emits: ['modalcat', 'add-item', 'clean-cat'],
        computed: {
            renderCat() {
                console.log('%cVue %ccatOptionComplect %crenderCat()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')

                let items = this.cat.items;
                let catView = {
                    itemscount: items.length
                };
                let hasCount = 0;

                let minCatPrice;
                let catSum = 0;
                let catOldSum = 0;

                items.forEach((item) => {
                    if (item.count) {
                        const price = item.price || item.minprice;
                        const validOldprice = item.old_price && item.discount > 0;
                        thumb_img_crop = item.thumb_img;
                        if(thumb_img_crop !== null)  {
                            thumb_img_crop = thumb_img_crop.replace(/\..*?$/, '');
                            catView.thumb_img = '//i.sdvk.ru' + thumb_img_crop;
                        }
                        catView.isMain = item.isMain;
                        catView.thumb_extention = item.thumb_extention;

                        catView.name = `${item.type || ''} ${item.brand || ''} ${item.name}`;
                        catView.count = (catView.count || 0) + item.count;
                        catView.selected = true;
                        catView.spec = item.spec;
                        catView.specClass = item.spec_class;
                        catView.specName = item.spec_name;
                        catView.discount = item.discount;
                        catSum += (Number(price) || 0) * item.count;
                        catOldSum += (validOldprice ? Number(item.old_price) : Number(price) || 0)
                            * item.count;
                        catView.url = item.url;
                        catView.avail = item.avail;
                        catView.in_complect = item.in_complect;
                        hasCount += 1;
                    }

                    const testPrice = item.price || item.minprice;
                    if (testPrice < minCatPrice || !minCatPrice) {
                        minCatPrice = testPrice;
                    }

                });

                if (hasCount) {
                    catView.price = rurFormat.format(catSum);
                    catView.oldprice = catOldSum > catSum ? rurFormat.format(catOldSum) : false;
                    catView.discount = catOldSum > catSum
                        ? Math.round((catOldSum - catSum) / catOldSum * 100)
                        : 0;
                    if (hasCount > 1) {
                        catView.name = '';
                        catView.url = '';
                    }
                }

                if (items.length == 1) {
                    catView.name = `${items[0].element_name || ''} ${items[0].brand || ''} ${items[0].name}`;
                    catView.url = items[0].url;
                }

                if (hasCount == 0) {
                    const validOldprice = items[0].old_price && items[0].discount > 0;

                    catView.thumb_img = items[0].thumb_img;
                    catView.thumb_extention = items[0].thumb_extention;

                    let pricePre = items.length > 1 ? "От " : "";

                    catView.price = pricePre + rurFormat.format(minCatPrice);
                    catView.oldprice = validOldprice ? rurFormat.format(items[0].old_price) : false;
                    catView.discount = items[0].discount;
                    catView.spec = items[0].spec;
                    catView.specClass = items[0].spec_class;
                    catView.avail = items[0].avail;
                }

                catView.hidden = this.index++ > this.showAllThreshold && this.showAllEnabled;

                return catView;
            },
        },
        methods: {
            cleanCat() {
                console.log('%cVue %ccatOptionComplect %ccleanCat()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                this.$emit('clean-cat', this.cat);
            },
            emitModal() {
                console.log('%cVue %ccatOptionComplect %cemitModal()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                this.$emit('modalcat', this.cat)
            },
            addOneItem() {
                console.log('%cVue %ccatOptionComplect %caddOneItem()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA');
                this.$emit('add-item', this.cat);
            },
        }
    }

    const modalItem = {
        template: '#modalItem',
        props: ['content'],
        methods: {
            addItem(index) {
                console.log('%cVue %cmodalItem %caddItem() ', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')

                const curCat = this.$props.content;

                curCat.items.forEach(item => {
                    delete item.count;
                });

                curCat.items[index].count = 1;

                console.dir(curCat.items[index]);
            },
            calcPriceCount(price, count) {
                console.log('%cVue %cmodalItem %ccalcPriceCount()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')

                if (!count) count = 1;
                return rurFormat.format(price * count);
            },
        }
    }

    const mainOptionsComplects = {
        template: '#mainOptionsComplects',
        components: {
            'cat-option-complect': catOptionComplect,
            'modal-item': modalItem,
        },
        props: ['cartsended'],
        emits: ['cart-sent'],
        data() {
            return {
                modalContent: false,
                categories: window.fetchp2p,
                showAllEnabled: false,
                showAllThreshold: 9
            }
        },
        computed: {
            checkSelected() {
                console.log('%cVue %cmainOptionsComplects %ccheckSelected()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')

                const arr = {
                    sumRaw: 0,
                    sum: 0,
                    sumOld: 0,
                    count: 0,
                    discount: 0,
                    discount_value: 0,
                    showCheck: false
                };
                const check = [];

                const selectedItems = [];
                this.categories.forEach(cat => {
                    cat.items.forEach(item => {
                        if (item.count && item.count > 0) selectedItems.push(item);
                    });
                });

                selectedItems.forEach(selectedItem => {
                    let price = selectedItem.price || selectedItem.minprice;
                    let oldPrice = selectedItem.old_price;
                    arr.count += 1;
                    arr.sum += Number(price) ? Number(price) * selectedItem.count : 0;
                    arr.sumRaw += Number(price) ? Number(price) * selectedItem.count : 0;
                    arr.sumOld += Number(oldPrice) ? Number(oldPrice) * selectedItem.count : 0;
                    arr.discount_value += Number(selectedItem.discount_value) ? Number(selectedItem.discount_value) : 0;
                    arr.showCheck = true;

                    check.push(selectedItem);
                });

                arr.showCheck = arr.count > 1 ? true : false;
                arr.sum = rurFormat.format(arr.sum);

                if (arr.sumOld > 0 && arr.sumOld != arr.sumRaw) {
                    arr.sumOld = rurFormat.format(arr.sumOld);
                    arr.discount_value = rurFormat.format(arr.discount_value);
                } else arr.sumOld = 0;

                arr.count += ' ' + declOfNum(arr.count, ['товар', 'товара', 'товаров']);

                window.check = check;
                window.dispatchEvent(new CustomEvent('complect-check-updated', { detail: check }));

                return arr
            }
        },
        methods: {
            addItemToCat(cat) {
                console.log('%cVue %cmainOptionsComplects %caddItemToCat()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                cat.items[0].count = 1;
            },
            cleanCat(cat) {
                console.log('%cVue %cmainOptionsComplects %ccleanCat()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                cat.items.forEach(item => { if (item.count) delete item.count; });
            },
            sendToCart() {
                console.log('%cVue %cmainOptionsComplects %csendToCart()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')

                sendCheckToCart(window.check);

                this.$emit('cart-sent');
                window.dispatchEvent(new CustomEvent('complect-cart-sent'));
            },
            locateToCart() {
                console.log('%cVue %cmainOptionsComplects %clocateToCart()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                window.location = '/cart/';
            },
            renderModal(cat) {
                console.log('%cVue %cmainOptionsComplects %crenderModal() ', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')

                this.modalContent = this.categories.find(c => c == cat);
                console.dir(this.modalContent);

                var catModal = new bootstrap.Modal(document.getElementById('modalOptionsComplects'));
                catModal.show();
            },
            cartSended() {
                console.log('%cVue %cmainOptionsComplects %ccartSended() true', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
            },
            showAllCats() {
                this.showAllEnabled = false;
            }
        },
        mounted() {
            this.showAllEnabled = this.categories.length > this.showAllThreshold + 1;

            const optionComplectSwiper = document.querySelector(`[data-swiper=product-options-complects] .swiper`);

            if (window.mobileTrigger) {
                initOptionsComplectsSwiper('#sliderOptionsComplects');
            } else {
                if (optionComplectSwiper.swiper) {
                    optionComplectSwiper.swiper.destroy(true, true);
                }
            }
        }
    }

    if (typeof Vue !== 'undefined') {
        const optionsComplectsApp = Vue.createApp({
            data() {
                return {
                    cartsended: false,
                }
            },
            methods: {
                cartSended() {
                    console.log('%cVue %coptionsComplectsApp %ccartSended() true', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                    this.cartsended = true;
                }
            }
        });
        optionsComplectsApp.component('main-options-complects', mainOptionsComplects)
        window.optionsComplectsApp = optionsComplectsApp.mount('#appOptionsComplects');

        window.addEventListener('complect-cart-sent', () => window.optionsComplectsApp.cartSended());
    }
}
